import { resolveApiBaseUrl } from '@minibook/shared';
import { DEFAULT_API_URL } from '../constants/booking.js';

/** Совпадает с web-master: .beclients.pro → global (без MAX в UI). */
export function getPublicSiteStage(): 'ru' | 'global' {
  const apiUrl = resolveApiBaseUrl({
    apiUrl: (import.meta as any).env?.VITE_API_URL,
    isDev: !!(import.meta as any).env?.DEV,
    devFallbackUrl: DEFAULT_API_URL,
    appendApiV1: true,
  });
  return apiUrl.includes('.beclients.pro') ? 'global' : 'ru';
}
